import { useQuery } from 'react-query';
import { appendQueryParamIfNotEmpty, generateQueryKey } from '../../../constants/hookConstants';
import { dataFetch, DIGGER_API_SUFFIX } from '../../../axios/customAxios';

export interface DeveloperTokensQueryParams {
  search?: string;
  rows: number;
  page: number;
}

const normalizeTokenResponse = (res: any) => {
  const payload = res?.data;
  if (payload?.data?.data && payload?.data?.meta) return payload.data;
  return payload;
};

const useGetDeveloperTokens = (identifier: string, params: DeveloperTokensQueryParams) => {
  const queryParams = new URLSearchParams();
  appendQueryParamIfNotEmpty(queryParams, 'withRevoked', 'true');
  appendQueryParamIfNotEmpty(queryParams, 'withExpired', 'true');
  appendQueryParamIfNotEmpty(queryParams, 'search', params.search?.trim?.() ?? params.search ?? '');
  appendQueryParamIfNotEmpty(queryParams, 'rows', String(params.rows));
  appendQueryParamIfNotEmpty(queryParams, 'page', String(params.page));

  const queryKey = generateQueryKey(identifier, queryParams);
  return useQuery(
    [`auth_tokens_developer_${queryKey}`],
    () => dataFetch.get(`${DIGGER_API_SUFFIX}auth/tokens/developer?${queryParams}`).then(normalizeTokenResponse),
  );
};

export default useGetDeveloperTokens;
